import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";

import PrintIcon from "@material-ui/icons/Print";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import moment from "moment";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../hooks/UseFetchData";
import Modal_Frame from "../biztran_controls/Modal_Frame";
import { DatePickerInput } from 'rc-datepicker';
import Session from "react-session-api";
import { Save } from "@material-ui/icons";

const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';

// function useApiRef() {
//   const apiRef = useRef(null);
//   const _columns = useMemo(
//     () =>
//       columns.concat({
//         field: "__HIDDEN__",
//         width: 0,
//         renderCell: (params) => {
//           apiRef.current = params.api;
//           return null;
//         },
//       }),
//     [columns]
//   );
//   return { apiRef, columns: _columns };
// }

const AddExpenseSheet = (props) => {
  //debugger;
  //const classes = useStyles();
  const [TravelRequestNo, setTravelRequestNo] = useState('');
  const [TravelRequestID, setTravelRequestID] = useState('');
  const [TravelRequestDate, setTravelRequestDate] = useState('');
  const [UserName, setUserName] = useState('');
  const [LocationToTravel, setLocationToTravel] = useState('');
  const [PurposeOfTravel, setPurposeOfTravel] = useState('');
  const [ExpenseSheetCreatedOn, setExpenseSheetCreatedOn] = useState('');
  const [ExpenseDate, setExpenseDate] = useState('');
  const [EmpID, setEmpID] = useState('');
  const [Status, setStatus] = useState('');
  const [EmpName, setEmpName] = useState('');
  const [AccountsApprovedByID, setAccountsApprovedByID] = useState(Session.get("UID"));
  const [PaidAmount, setPaidAmount] = useState('');
  const [AccountsApprovedOn, setAccountsApprovedOn] = useState('')
  const [TravelFrom, setTravelFrom] = useState('');
  const [ModeOfTravelID, setModeOfTravelID] = useState('');
  const [ApprovedBy, setApprovedBy] = useState('');
  const [ApprovedOn, setApprovedOn] = useState('');
  const [AccApprovedBy, setAccApprovedBy] = useState(Session.get("UserName"));
  const [responseList, ListfetchData] = UseFetchData();
  const [AccApprovedOn, setAccApprovedOn] = useState('');
  const [PlannedAmount, setPlannedAmount] = useState('');
  const [tolExpAmount, settolExpAmount] = useState('');

  const [tolExpAppAmount, settolExpAppAmount] = useState('');
  const [tolAccAppAmount, settolAccAppAmount] = useState('');

  const [PaidOn, setPaidOn] = useState('');
  const [pagename, setpagename] = useState(props.pagename);
  const [flag, setflag] = useState(props.pagename == "Home" ? true : true);
  const [flag01, setflag01] = useState(false);
  // console.log(props.poppopupData.[FunctionLocation);
  const [TotalPaidAmount, setTotalPaidAmount] = useState('');
  const [PaymentDetails, setPaymentDetails] = useState('');
  const [rows, setRows] = useState([]);
  const [LocationFromTravel, setTravelFromLocation] = useState([]);
  const [columns, setColumns] = useState([]);
  const [response, fetchData] = UseFetchData();
  const [responseAccAp, AccApfetchData] = UseFetchData();
  const [response01, fetchData01] = UseFetchData();
  const [responseprint, fetchDataprint] = UseFetchData();
  // const fromdate = new Date()
  // const [ToDate, setToDate] = useState(todate.toISOString());
  const [defaultToDate, setdefaultToDate] = useState('');
  const [ApprovalStatus, setApprovalStatus] = useState([]);

  const [label, setlabel] = useState(false);
  const [label01, setlabel01] = useState(false);
  const [label02, setlabel02] = useState(false);
  const [label03, setlabel03] = useState(false);
  const [label04, setlabel04] = useState(false);
  const [label05, setlabel05] = useState(false);
  const [label06, setlabel06] = useState(false);
  const [label07, setlabel07] = useState(false);

  const poppopupData = () => {
    //debugger;
    const bodyFormData = new FormData();
    bodyFormData.append("TravelRequestID", props.TravelRequestID);
    ListfetchData("Dashboard/GetbyID", bodyFormData);
  }

  const popupGrid = () => {
    //debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("TravelRequestID", props.TravelRequestID);
    fetchData("Dashboard/ExpenseListWeb", bodyFormData);
  }

  const SaveExpense = (value) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("TravelRequestID", value.TravelRequestID);
    bodyFormData.append("EmpID", Session.get("UID"));
    bodyFormData.append("ExpenseID", value.id);

    if (value.AccountsRemarks !== null && value.AccountsRemarks !== "") {
      bodyFormData.append("AccountsRemarks", value.AccountsRemarks);
    } else {
      bodyFormData.append("AccountsRemarks", "");
    }
    if (value.AccountsApprovedAmt !== null && value.AccountsApprovedAmt !== "") {
      if (!isNaN(+value)) {
        alert('Please Enter Numeric Value only !..');
        return;
      }
      else {
        bodyFormData.append("AccountsApprovedAmt", value.AccountsApprovedAmt);
      }
    } else {

      alert('Please Enter Accounts Approved Amount !...');
      return;
    }

    AccApfetchData("Dashboard/ExpAccApproval", bodyFormData);
  }

  useEffect(() => {
    //debugger;
    poppopupData();
    popupGrid();
    console.log("pagename", props.pagename);
  }, [])


  useEffect(() => {
    //debugger;
    if ((responseAccAp.Response === true)) {
      alert('Data Saved Succesfully.');
      // setRevised("false");
      // props.setOpen(false);
    }
    else if (responseAccAp.Response === false) {
      alert('Failed.');
    }
  }, [responseAccAp])

  useEffect(() => {
    if (response01.Response == true) {
      //debugger;
      props.setOpen(false);
      props.PopulateData();
    }

  }, [response01])


  const submitForm = () => {
    if (pagename !== "Home") {
      const bodyFormData = new FormData();
      bodyFormData.append("TravelRequestID", props.TravelRequestID);
      bodyFormData.append("PaidOn", PaidOn);
      bodyFormData.append("TotalPaidAmount", TotalPaidAmount);
      bodyFormData.append("PaymentDetails", PaymentDetails);
      fetchData01("Dashboard/PaymentUpdate", bodyFormData);
    } else {
      const bodyFormData = new FormData();
      bodyFormData.append("TravelRequestID", props.TravelRequestID);
      bodyFormData.append("EmpID", Session.get("UID"));
      fetchData01("Dashboard/AccApproval", bodyFormData);
    }


  };


  const Print = () => {
    debugger;
    if (props.TravelRequestID != "" && props.TravelRequestID != null && props.TravelRequestID != undefined) {
      const bodyFormData = new FormData();
      bodyFormData.append("TravelRequestID", props.TravelRequestID);
      fetchDataprint("Dashboard/PDFGenerate", bodyFormData);
    }
  }
  useEffect(() => {
    debugger;
    if (responseprint != undefined && responseprint.length > 0) {
      window.open(responseprint[0].FileURL);
    }
  }, [responseprint])


  useEffect(() => {
    if (responseList !== undefined && responseList.length > 0) {
      //debugger;
      setTravelRequestNo((responseList[0].TravelRequestNo));
      setTravelRequestDate(moment(responseList[0].TravelRequestDate).format('DD-MMM-yyyy'));
      setUserName(responseList[0].EmpName);
      setLocationToTravel(responseList[0].LocationToTravel);
      setTravelFromLocation(responseList[0].LocationFromTravel);
      setPurposeOfTravel(responseList[0].PurposeOfTravel);
      setExpenseSheetCreatedOn(responseList[0].ExpenseSheetCreatedOn);
      setEmpName(responseList[0].EmpName);
      setApprovedBy(responseList[0].ApprovedBy);
      setPlannedAmount(responseList[0].ApproxExpAmount);
      setApprovedOn(responseList[0].ApprovedOn != null && responseList[0].ApprovedOn != "" ? moment(responseList[0].ApprovedOn).format('DD-MMM-yyyy') : null);
      settolExpAmount(responseList[0].TotalExpenseAmount);
      settolExpAppAmount(responseList[0].TotalApprovedAmount);
      settolAccAppAmount(responseList[0].TotalAccAppAmt);
      setPaidOn(responseList[0].PaidOn != null && responseList[0].PaidOn != "" ? moment(responseList[0].PaidOn).format('DD-MMM-yyyy') : null);
      setTotalPaidAmount(responseList[0].TotalPaidAmount);
      setPaymentDetails(responseList[0].PaymentDetails);
      setStatus(responseList[0].ApprovalStatus);
      if (responseList[0].ApprovalStatus == "Exp Approved") {
        setflag01(true)
        setflag(false)

      }
      setApprovalStatus(responseList[0].ApprovalStatus);
      // setFromDate(moment(responseList[0].FromDate).format('YYYY-MM-DD'));
      // setToDate(moment(responseList[0].ToDate).format('YYYY-MM-DD'));
      // setDescription(responseList[0].Description);
      // setAppExpAmt(responseList[0].AppExpAmt);
      // setApprovalStatus(responseList[0].ApprovalStatus);
      // setExpenseApproversRemarks(responseList[0].ExpenseApproversRemarks);
    }
  }, [responseList]);


  const openPath = (row) => {
    debugger;
    window.open(row.formattedValue);

  };
  useEffect(() => {
    //debugger;
    const gridCols = [
      {
        field: "id",
        headerName: "Save",
        //renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { SaveExpense(params.row) }} >Save</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        hide: pagename == "Home" || Status == "Exp Approval" ? false : true,
        width: 70,
      },
      {
        field: "AccountsApprovedAmt",
        headerName: "Acc Approved Amt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 210,
        editable: pagename == "Home" || Status == "Exp Approval" ? true : false,

        backgroundcolor: 'white'
      },
      {
        field: "AccountsRemarks",
        headerName: "Acc Remarks",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        editable: pagename == "Home" || Status == "Exp Approval" ? true : false,
      },
      {
        field: "ExpenseDate",
        headerName: "Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
        type: 'date',
      },
      {
        field: "ExpenseType",
        headerName: "Exp type",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "TravelFrom",
        headerName: "From",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "TravelTo",
        headerName: "To",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "ModeOfTravel",
        headerName: "Mode Of Travel",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "DistanceTravelledInKm",
        headerName: "Distance",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "TimeTakenInHrs",
        headerName: "Travel Time",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "CityType",
        headerName: "City Type",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "CheckInDate",
        headerName: "Check In Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        type: 'date',
      },
      {
        field: "CheckOutDate",
        headerName: "Check Out Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 190,
        type: 'date',
      },
      {
        field: "NoOfDaysStayed",
        headerName: "Days Stayed",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "ExpenseAmount",
        headerName: "Exp Amt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "Remarks",
        headerName: "Remarks",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 350,
      },
      {
        field: "UpperCeiling",
        headerName: "Upper Ceiling",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "ApprovedAmt",
        headerName: "Mngr Amt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "ApproverRemarks",
        headerName: "Mngr Remarks",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },

      {
        field: "At1",
        headerName: "Att 1",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openPath(params); }} >{params.formattedValue === null ? "" : "View"}</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "Attachment2",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openPath(params); }} >{params.formattedValue === null ? "" : "View"}</a> </strong>),
        headerName: "Att 2",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "Attachment3",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openPath(params); }} >{params.formattedValue === null ? "" : "View"}</a> </strong>),
        headerName: "Att 3",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",

        width: 150,
      },
    ];
    if (response.Main !== undefined) {
      debugger;
      setColumns(gridCols);

      setRows(response.Main);
    }

  }, [response]
  );




  return (<div>
    <Formik initialValues={{
      TravelRequestNo: TravelRequestNo, ExpenseDate: ExpenseDate, EmpID: EmpID, TravelFrom: TravelFrom, ModeOfTravelID: ModeOfTravelID,
      ApprovedBy: ApprovedBy, ApprovedOn: ApprovedOn, AccApprovedBy: AccApprovedBy, AccApprovedOn: AccApprovedOn, PlannedAmount: PlannedAmount, tolExpAmount: tolExpAmount,
      PaidOn: PaidOn, PaidAmount: PaidAmount, PaymentDetails: PaymentDetails
    }}
      onSubmit={() => submitForm()}
      enableReinitialize>
      {formik => {
        return <Form>
          <Grid item xs={12} spacing={1} container direction="row">
            <Grid item xs={12} spacing={1} container direction="row">
              <Grid item xs={2}>
                <label
                  htmlFor={"TravelRequestNo"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"TR No/Exp No "}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"TravelRequestNo"}
                  style={{
                    // display: "block",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  {TravelRequestNo}
                </label>
              </Grid>
              <Grid item xs={2}>
                <label
                  htmlFor={"ExpenseDate"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Exp Sheet Date"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"TravelRequestDate"}
                  style={{
                    // display: "block",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  {TravelRequestDate}
                </label>
              </Grid>
              <Grid item xs={2}>
                <label
                  htmlFor={"EmpID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Employee"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"EmpName"}
                  style={{
                    // display: "block",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  {EmpName}
                </label>
              </Grid>

            </Grid>

            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row">
              <Grid item xs={2}>
                <label
                  htmlFor={"TravelFromLocation"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"From Location"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"LocationFromTravel"}
                  style={{
                    // display: "block",
                    fontWeight: "bold",
                    width: "100%",
                  }}
                >
                  {LocationFromTravel}
                </label>
              </Grid>
              <Grid item xs={2}>
                <label
                  htmlFor={"TravelFrom"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"To Location"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"LocationToTravel"}
                  style={{
                    // display: "block",
                    fontWeight: "bold",
                    width: "100%",
                  }}
                >
                  {LocationToTravel}
                </label>
              </Grid>
              <Grid item xs={2}>
                <label
                  htmlFor={"ModeOfTravelID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Purpose Of Travel"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"PurposeOfTravel"}
                  style={{
                    // display: "block",
                    fontWeight: "bold",
                    width: "100%",
                  }}
                >
                  {PurposeOfTravel}
                </label>
              </Grid>

            </Grid>
            <Grid item xs={12} spacing={1} container direction="row">
              <Grid item xs={2}>
                <label
                  htmlFor={"ApprovedBy"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Approved By"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"ApprovedBy"}
                  style={{
                    // display: "block",
                    fontWeight: "bold",
                    width: "100%",
                  }}
                >
                  {ApprovedBy}
                </label>
              </Grid>
              <Grid item xs={2}>
                <label
                  htmlFor={"ApprovedOn"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Approved On"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"ApprovedOn"}
                  style={{
                    // display: "block",
                    fontWeight: "bold",
                    width: "100%",
                  }}
                >
                  {ApprovedOn}
                </label>
              </Grid>
              {/* <Grid item xs={2}>
                <label
                  htmlFor={"AccApprovedBy"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Acc Approved By"}
                </label>
              </Grid> */}
              {/* <Grid item xs={2} >
                <label
                  htmlFor={"AccApprovedBy"}
                  style={{
                    // display: "block",
                    fontWeight: "bold",
                    width: "100%",
                  }}
                >
                  {AccApprovedBy}
                </label>
              </Grid> */}

            </Grid>

            <Grid item xs={12} spacing={1} container direction="row">

              <Grid item xs={2}>
                <label
                  htmlFor={"ApproxExpAmt"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Approx Exp Amt"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"ApproxExpAmt"}
                  style={{
                    // display: "block",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  {PlannedAmount}
                </label>
              </Grid>


              <Grid item xs={2}>
                <label
                  htmlFor={"tolExpAmount"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Exp Amt"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"tolExpAmount"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    width: "100%",
                  }}
                >
                  {tolExpAmount}
                </label>
              </Grid>

              <Grid item xs={2}>
                <label
                  htmlFor={"ExpAppAmount"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Mngr Approve Amt"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"ExpAppAmount"}
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    width: "100%",
                  }}
                >
                  {tolExpAppAmount}
                </label>
              </Grid>
            </Grid>

            {/* <Grid item xs={12} spacing={1} container direction="row">
              <Grid item xs={2}>
                <label
                  htmlFor={"PaidOn"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Paid On "}
                </label>
              </Grid>
              <Grid item xs={4} >
                <BiztranControlsFormik
                  control="input"
                  type="date"
                  name="PaidOn"
                  // disabled={true}
                  onChange={(e) => setPaidOn(e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <label
                  htmlFor={"PaidAmount"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Paid Amount"}
                </label>
              </Grid>
              < Grid item xs={4} >
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="PaidAmount"
                  value={TotalPaidAmount}
                  onChange={(e) => {
                    setTotalPaidAmount(e.target.value)
                  }}
                />
              </Grid>

            </Grid>

            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
              <Grid item xs={2}>
                <label
                  htmlFor={"PaymentDetails"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Payment Details"}
                </label>
              </Grid>
              <Grid item xs={10} >
                <BiztranControlsFormik
                  autoFocus="autofocus"
                  control="input"
                  type="text"
                  name="PaymentDetails"
                  //ref={ref}
                  value={PaymentDetails}
                  //options={ASIcmb}                   
                  onChange={(e) => {
                    setPaymentDetails(e.target.value)
                    //handleChange()
                  }}
                />
              </Grid>
            </Grid> */}
            <Grid item xs={12} spacing={1} container direction="row">
              <Grid item xs={2}>
                <label
                  htmlFor={"AccApproxAmt"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Acc Approve Amt"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <label
                  htmlFor={"AccApproxAmt"}
                  style={{
                    // display: "block",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  {tolAccAppAmount}
                </label>
              </Grid>
            </Grid>
            <Grid item xs={12} spacing={1} container direction="row">

              <Grid item xs={2}>
                <label
                  htmlFor={"PaidOn"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Paid On "}
                </label>
              </Grid>
              {pagename != "Home" ?
                <Grid item xs={4} >
                  <BiztranControlsFormik
                    control="input"
                    type="date"
                    name="PaidOn"
                    // disabled={true}
                    onChange={(e) => setPaidOn(e.target.value)}
                  />
                </Grid> :
                <Grid item xs={2}>
                  <label
                    htmlFor={"PaidOn"}
                    style={{
                      // display: "block",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {PaidOn}
                  </label>
                </Grid>
              }
              <Grid item xs={2}>
                <label
                  htmlFor={"PaidAmount"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Paid Amount"}
                </label>
              </Grid>
              <Grid item xs={4} >
                {pagename != "Home" ?
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="PaidAmount"
                    value={TotalPaidAmount}
                    onChange={(e) => {
                      setTotalPaidAmount(e.target.value)
                    }}
                  /> :
                  <Grid item xs={2}>
                    <label
                      htmlFor={"PaidAmount"}
                      style={{
                        // display: "block",
                        fontWeight: "bold",
                        width: "100%",
                      }}
                    >
                      {TotalPaidAmount}
                    </label>
                  </Grid>
                }
              </Grid>

            </Grid>

            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
              <Grid item xs={2}>
                <label
                  htmlFor={"PaymentDetails"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Payment Details"}
                </label>
              </Grid>
              <Grid item xs={10} >
                {pagename != "Home" ?
                  <BiztranControlsFormik
                    autoFocus="autofocus"
                    control="input"
                    type="text"
                    name="PaymentDetails"
                    //ref={ref}
                    value={PaymentDetails}
                    //options={ASIcmb}                   
                    onChange={(e) => {
                      setPaymentDetails(e.target.value)
                      //handleChange()
                    }}
                  /> :
                  <label
                    htmlFor={"PaymentDetails"}
                    style={{
                      // display: "block",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {PaymentDetails}
                  </label>
                }
              </Grid>
            </Grid>
            <BiztranControls.DataGrid
              rowHeight={25}
              headerHeight={34}
              rows={rows}
              columns={columns}
              rowsPerPage={5}
              pageSize={5}
              checkboxSelection={false}
              autoHeight={true}
              autoPageSize={true}
              Width="107%"

              Height="250px"
              // hideFooter={true}
              // rowsPerPageOptions={[5, 10]}
              hideFooterPagination={false}
            />
            <Grid item xs={12}>
              <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', marginTop: 5, justifyContent: 'center', alignContent: "center" }}>

                  <BiztranControls.Button
                    text="Approve"
                    startIcon={<SaveIcon />}
                    // onPress={submitForm}
                    type="submit"
                  />
                  <BiztranControls.Button
                    text="Print"
                    startIcon={<PrintIcon />}
                    onClick={Print}
                  />
                  <BiztranControls.Button
                    text="CLOSE"
                    startIcon={<CloseIcon />}
                    onClick={() => { props.setOpen(false); }}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </Form>
      }}
    </Formik>

  </div >)

}
export default AddExpenseSheet;